module.exports = __webpack_public_path__ + "media/images/photos/4-3752d931f91e204c8df554fed10da3ca.jpg";